var blog = {

    init: function () {
        if ($(".blog-comment").length > 0)
        {
            this.sortByDate();     
        }
       
    },

    sortByDate: function () {
        var sortedResult;
        var dataResult = [];
        $(".blog-comment").each(function () {
            var id = $(this).data("id");
            var date = new Date($(this).data("date"));
            var html = $(this).get();
            dataResult.push({ id: id, html: html, date: date });           
        });
        $(".blog-comments__sort input").click(function () {

            if ($(this).attr("id") === "radio-newest") {                
                // newest
                dataResult.sort(function (a, b) {
                    return b.id - a.id;
                });
            }
            else if ($(this).attr("id") === "radio-oldest") {
                // oldest
                dataResult.sort(function (a, b) {
                    return a.id - b.id;
                });
                
            }
            $(".blog-comments__comment-list").html("");
            $.each(dataResult, function () {
                $(".blog-comments__comment-list").append(this.html);
            })
        });
    } 
}

$(document).ready(function () {
    blog.init();
});